import React from 'react';
import ProgramationEnIllustration from 'containers/Programmations/assets/en/Programmation/Loadable';
import ProgramationFrIllustration from 'containers/Programmations/assets/fr/Programmation/Loadable';
import ProgressionEnIllustration from 'containers/Programmations/assets/en/Progression/Loadable';
import ProgressionFrIllustration from 'containers/Programmations/assets/fr/Progression/Loadable';

export function getProgrammationIllusration(locale: 'en' | 'fr') {
  if (locale === 'en') {
    return <ProgramationEnIllustration />;
  }

  return <ProgramationFrIllustration />;
}

export function getProgressionIllustration(locale: 'en' | 'fr') {
  if (locale === 'en') {
    return <ProgressionEnIllustration />;
  }

  return <ProgressionFrIllustration />;
}
